
    document.addEventListener('DOMContentLoaded', function () {
        const drawer = document.querySelector('.mobile-navigation-drawer');
        if (!drawer) return;
        const focusableSelectors = `
            a[href],
            button:not([disabled]),
            [tabindex]:not([tabindex="-1"])
        `;
        function getFocusableElements() {
            return Array.from(drawer.querySelectorAll(focusableSelectors))
                .filter(el => el.offsetParent !== null); // visible only
        }
        drawer.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            const focusable = getFocusableElements();
            if (!focusable.length) return;
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                closeMenu();
                return;
            }

            if (!e.shiftKey && document.activeElement === last) {
                closeMenu();
                return;
            }
        });
    
        function closeMenu() {
            const closeBtn = drawer.querySelector('.mobile-nav-toggle');
            if (closeBtn) {
                closeBtn.click();
            }
            const trigger = document.querySelector('[aria-controls="mobile-menu"], .menu-toggle');
            if (trigger) {
                trigger.focus();
            }
        }
    });
  
//Cart page remove reading
function announceCartRemoval(el) {
    const title = el.getAttribute('data-product-title');
    const region = document.getElementById('cart-live-region');
    if (region) {
      region.textContent = ''; 
      requestAnimationFrame(() => {
        region.textContent = title + ' has been removed from your cart.';
      });
    }
  }
  //add tocart screen reading
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-add-to-cart-text]');
    if (!btn) return;
    const announceSuccess = () => {
      const region = document.getElementById('cart-live-region');
      if (!region) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = 'Item added to your cart.';
      });
    };
    document.addEventListener('cart:add:success', announceSuccess, { once: true });
  });


  //pdp
  document.addEventListener('DOMContentLoaded', () => {
    const sizeList = document.getElementById('size-options-list');
    const observer = new MutationObserver(() => {
      if (sizeList.classList.contains('show')) {
        sizeList.style.height = sizeList.scrollHeight + 'px';
        if (sizeList.scrollHeight > 130) {
          sizeList.style.height = '130px';
        }
        sizeList.style.webkitOverflowScrolling = 'touch';
        sizeList.style.overflowY = 'auto';
      } else {
        sizeList.style.height = '';
        sizeList.style.webkitOverflowScrolling = '';
        sizeList.style.overflowY = '';
      }
    });
    observer.observe(sizeList, { attributes: true, attributeFilter: ['class'] });
  });

  //pdp-nonfocusable image
  document.addEventListener('DOMContentLoaded', () => {
    const imageBlocks = document.querySelectorAll('.product-block__image');
    imageBlocks.forEach((block) => {
      const img = block.querySelector('img');
      if (img && !img.getAttribute('alt')) {
        img.setAttribute('alt', block.getAttribute('aria-label') || '');
      }
      block.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          block.click();
        }
      });
    });
  });

// pdp sizeguide
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('modal-size-guide');
  if (!modal) return;
  const scrollContainer = modal.querySelector('.modal__content');
  if (!scrollContainer) return;
  let startY = 0;
  let startX = 0;
  function lockBodyScroll() {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.width = '100%';
  }
  function unlockBodyScroll() {
    const scrollY = document.body.style.top;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
  modal.addEventListener('touchmove', (e) => {
    if (!scrollContainer.contains(e.target)) {
      e.preventDefault();
    }
  }, { passive: false });
  scrollContainer.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY;
    startX = e.touches[0].clientX;
  }, { passive: true });
  scrollContainer.addEventListener('touchmove', (e) => {
    const deltaY = e.touches[0].clientY - startY;
    const deltaX = e.touches[0].clientX - startX;
    const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
    if (isHorizontalSwipe) {
      e.preventDefault();
      return;
    }
    const atTop = scrollTop === 0 && deltaY > 0;
    const atBottom = scrollTop + clientHeight >= scrollHeight && deltaY < 0;
    if (atTop || atBottom) {
      e.preventDefault();
    }
  }, { passive: false });
  const observer = new MutationObserver(() => {
    if (modal.hasAttribute('open') || modal.classList.contains('is-open')) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  });

  observer.observe(modal, { attributes: true });
  modal.querySelector('.js-close-modal')?.addEventListener('click', unlockBodyScroll);
});

 //pdp wishlist
 document.querySelectorAll('.swym-add-to-wishlist-view-product').forEach(btn => {
  const isAdded = btn.classList.contains('swym-added');
  btn.setAttribute('aria-label', isAdded ? 'Remove from Wishlist' : 'Add to Wishlist');

  const observer = new MutationObserver(() => {
    const isAdded = btn.classList.contains('swym-added');
    btn.setAttribute(
      'aria-label',
      isAdded ? 'Remove from Wishlist' : 'Add to Wishlist'
    );
  });

  observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
});

//plp radio button
document.querySelectorAll('[role="listbox"]').forEach(listbox => {
  const options = () => [...listbox.querySelectorAll('[role="option"]:not(.hide)')];
  listbox.addEventListener('click', e => {
    const option = e.target.closest('[role="option"]');
    if (!option) return;
    options().forEach(o => {
      o.setAttribute('aria-selected', 'false');
      o.setAttribute('tabindex', '-1');
    });
    option.setAttribute('aria-selected', 'true');
    option.setAttribute('tabindex', '0');
  });
  listbox.addEventListener('keydown', e => {
    const opts = options();
    const current = opts.findIndex(o => o.getAttribute('aria-selected') === 'true');
    let next = current;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      next = (current + 1) % opts.length;
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      next = (current - 1 + opts.length) % opts.length;
    } else if (e.key === 'Enter' || e.key === ' ') {
      opts[current]?.click();
      return;
    } else {
      return;
    }

    e.preventDefault();
    opts.forEach((o, i) => {
      o.setAttribute('aria-selected', i === next ? 'true' : 'false');
      o.setAttribute('tabindex', i === next ? '0' : '-1');
    });
    opts[next].focus();
  });
});
//cart drawer close
const labelSpan = cartDrawer.querySelector('#cart-drawer-label');
if (labelSpan) {
    labelSpan.focus();
}